import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { Link } from 'react-router-dom'
import { loginUser, discoverLogin, clearDiscover } from "../actions/authActions";
import { ReactComponent as Titan } from "../assets/titan.svg"
import TokenInvalid from "./tokenInvalid.jsx"
import { isEmailValid } from "./utils";
import { FormattedMessage } from "react-intl";
import { DISCOVER_METHOD } from "../constants/auth";

class LoginForm extends Component {
  state = {
    emailEntered: "",
    passwordEntered: ""
  }
  constructor(props) {
    super(props);
    this.handleEmailSubmit = this.handleEmailSubmit.bind(this);
    this.handlePasswordSubmit = this.handlePasswordSubmit.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleUseDifferentEmail = this.handleUseDifferentEmail.bind(this);
  }

  handleEmailChange = (e) => {
    const emailEntered = e.target.value;
    this.setState(prevState => ({
      ...prevState,
      emailEntered: emailEntered
    }))
  }

  handlePasswordChange = (e) => {
    const passwordEntered = e.target.value;
    this.setState(prevState => ({
      ...prevState,
      passwordEntered: passwordEntered
    }))
  }

  handleEmailSubmit = e => {
    e.preventDefault();
    this.props.discoverLogin(this.state.emailEntered.trim())
  };

  handlePasswordSubmit = e => {
    e.preventDefault();
    this.props.loginUser(this.state.emailEntered.trim(), this.state.passwordEntered)
  };

  handleUseDifferentEmail = () => {
    this.setState({ passwordEntered: "" })
    this.props.clearDiscover()
  }

  renderEmailStep = () => {
    return (
      <form onSubmit={this.handleEmailSubmit}>
        <h4 className="input-label">
          <FormattedMessage id="login-form-email-header" />
        </h4>
        <div className="input input-box input-div">
          <input
            className="no-border-input"
            placeholder="john.doe@flock.com"
            onChange={this.handleEmailChange}
            value={this.state.emailEntered} />
        </div>
        <button type="primary"
          className="button button-primary login-form-button"
          disabled={this.props.discoverInProgress || !isEmailValid(this.state.emailEntered.trim())}>
          <FormattedMessage id="login-form-continue" />
        </button>
        {this.props.discoverError && <div className="error login-error"> {this.props.discoverError} </div>}
      </form>
    )
  }

  renderPasswordStep = () => {
    return (
      <form onSubmit={this.handlePasswordSubmit}>
        <div className="login-email-display">
          <span className="login-email-text">{this.state.emailEntered}</span>
          <span className="use-different-email-link" onClick={this.handleUseDifferentEmail}>
            <FormattedMessage id="login-form-use-different-email" />
          </span>
        </div>
        <div className="password-label-container">
          <h4 className="input-label">
            <FormattedMessage id="login-form-password-header" />
          </h4>
          <Link className="forgot-password-link" to="/forgot-password">
            <FormattedMessage id="login-form-forgot-password" />
          </Link>
        </div>
        <div className="input input-box input-div">
          <input
            className="no-border-input"
            type="password"
            placeholder="Enter your Password"
            autoFocus
            onChange={this.handlePasswordChange}
            value={this.state.passwordEntered} />
        </div>
        <button type="primary"
          className="button button-primary login-form-button"
          disabled={this.props.isLoggingIn || !this.state.passwordEntered}>
          <FormattedMessage id="login-button-text" />
        </button>
        {this.props.discoverError && <div className="error login-error" > {this.props.discoverError} </div>}
        {this.props.loginError && <div className="error login-error" > {this.props.loginError} </div>}
      </form>
    )
  }

  render() {
    const isPasswordStep = this.props.discoverMethod === DISCOVER_METHOD.PASSWORD;
    return (
      <div className="table-body">
        <div className="login-logo" >
          <Titan />
        </div>
        <div className="login-layout">
          <div>
            <h3 className="login-heading">
              <FormattedMessage id="login-form-header" />
            </h3>
          </div>
          <div className="form">
            {isPasswordStep ? this.renderPasswordStep() : this.renderEmailStep()}
          </div>
        </div>
        {this.props.isTokenInvalid ? <TokenInvalid /> : ""}
      </div >
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    isLoggingIn: state.auth.isLoggingIn,
    loginError: state.auth.loginError,
    isTokenInvalid: state.auth.isTokenInvalid,
    discoverInProgress: state.auth.discoverState.inProgress,
    discoverMethod: state.auth.discoverState.method,
    discoverError: state.auth.discoverState.error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators({ loginUser, discoverLogin, clearDiscover }, dispatch)
  }
};


export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
